import styles from './WaitlistCta.module.css';

export default function WaitlistCta({ onOpen }) {
  return (
    <div className={styles.wrapper}>
      <button className={styles.button} onClick={onOpen}>
        &gt; JOIN_WAITLIST
      </button>
    </div>
  );
}
